<!-- Hero -->
<section id="hero" class="flexible">
  <div class="container flexible">
    <header class="flexible flexible-column">
      <h3 class="text-white text-center">{{'front_landing.reference_your_event_et_sell'| translate}}</h3>
      <a [routerLink]="['/manage/event/create']" title="Montrez-moi" class="btn">{{'front_landing.create_an_event'| translate}}</a>
    </header>
  </div>
</section>

<!-- Agenda -->
<section id="agenda" class="paddings pro-section">
  <div class="container">
    <header class="text-center">
      <h1 class="text-uppercase text-blue">{{'front_landing.diary'| translate}}</h1>
      <p>
        {{'front_landing.our_visitors_are_your_client'| translate}}
      </p>
    </header>

    <div id="banners-carousel" class="carousel slide prevent-carousel-remove" data-ride="carousel">
      <div class="carousel-inner prevent-carousel-remove" role="listbox">
        <div class="carousel-item prevent-carousel-remove active">
          <div class="landing-carousel-item landing-carousel-item--first row">
            <div class="landing-carousel-item__col col-md-5 text-left">
              <header class="text-blue landing-carousel__title"> {{'front_landing.the_diairy_a_brodacast_network'| translate}}</header>
              <p class="landing-carousel__content">{{'front_landing.however_you_want_to_make_your_event_'| translate}}
              </p>
              <a href="/manage/event/create" title="En savoir plus" class="btn">{{'front_landing.know_more'| translate}}</a>
            </div>
            <div class="landing-carousel-item__col col-md-7">
              <img src="assets/imgs/landing/SLIDE_1.png" class="img-fluid" alt="Image iPhone"/>
            </div>
          </div>
        </div>
        <div class="carousel-item prevent-carousel-remove">
          <div class="landing-carousel-item landing-carousel-item--second row">
            <div class="landing-carousel-item__col col-md-7 text-left align-items-center">
              <header class="text-blue landing-carousel__title">{{'front_landing.create_reference_quickly_'| translate}}</header>
              <div class="landing-carousel__content">
                <p>{{'front_landing.by_creating_your_eventand_by_referancing_them'| translate}}</p>
                <p>{{'front_landing.the_akces_filter_is_made_to_'| translate}}</p>
              </div>
            </div>
            <div class="landing-carousel-item__col col-md-5">
              <img src="assets/imgs/landing/IPHONE_X.png" alt="Image iPhone" class="img-fluid"/>
            </div>
          </div>
        </div>
        <div class="carousel-item prevent-carousel-remove">
          <div class="landing-carousel-item landing-carousel-item--three row">
            <div class="landing-carousel-item__col col-md-6 text-left align-items-center">
              <header class="text-blue landing-carousel__title">{{'front_landing.the_solution_for_all_type_event'| translate}}</header>
              <p class="landing-carousel__content">{{'front_landing.however_you_is_coach_of_'| translate}}</p>
              <!-- <a href="/" title="En savoir plus" class="btn">En savoir plus</a> -->
            </div>
            <div class="landing-carousel-item__col col-md-6">
              <img src="assets/imgs/landing/SLIDE 3.png" class="img-fluid" alt="Image iPhone">
            </div>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#banners-carousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">{{'front_landing.previous'| translate}}</span>
      </a>
      <a class="carousel-control-next" href="#banners-carousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">{{'front_landing.next'| translate}}</span>
      </a>
    </div>
  </div>
</section>

<!-- Communiquez -->
<section id="communiquez" class="paddings pro-section">
  <div class="container">
    <header class="text-center">
      <h2 class="text-uppercase text-blue">{{'front_landing.communiquate'| translate}}</h2>
      <p>
        {{'front_landing.supports_made_to_diffuse_picture'| translate}}
      </p>
    </header>
    <div class="wrapper flexible">
      <div>
        <span class="img-wrapper"><img src="assets/imgs/landing/FESTIVAL.png" class="img-fluid" alt="Communiquez"></span>
      </div>
      <div>
        <ul class="list-wrapper">
          <li>
            <header class="text-blue flexible">
              <span>
                <img src="assets/imgs/landing/brush_icon.png" width="15" alt="..."/>
              </span>
              <h3 class="inline-block">{{'front_landing.personnalised_ticket'| translate}}</h3>
            </header>
            <p>
              {{'front_landing.put_your_ticket_a_the_'| translate}}
            </p>
          </li>
          <li>
            <header class="text-blue flexible">
              <span>
                <img src="assets/imgs/landing/glob_icon.png" width="15" alt="..."/>
              </span>
              <h3 class="inline-block">{{'front_landing.mini_site'| translate}}</h3>
            </header>
            <p>
              {{'front_landing.describe_your_event_and_'| translate}}
            </p>
          </li>
          <li>
            <header class="text-blue flexible">
              <span>
                <img src="assets/imgs/landing/envelop_icon.png" width="15" alt="..."/>
              </span>
              <h3 class="inline-block">{{'front_landing.invitation'| translate}}</h3>
            </header>
            <p>
              {{'front_landing.select_your_convive_and_offer'| translate}}
            </p>
          </li>
          <li>
            <header class="text-blue flexible">
              <span>
                <img src="assets/imgs/landing/user_card_icon.png" width="15" alt="...."/>
              </span>
              <h3 class="inline-block">{{'front_landing.badge'| translate}}</h3>
            </header>
            <p>
              {{'front_landing.manage_and_securise_the_access_levels'| translate}}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Vendez -->
<section id="vendez" class="paddings pro-section">
  <div class="container">
    <header class="text-center">
      <h2 class="text-uppercase text-blue">{{'front_landing.sell'| translate}}</h2>
      <p>
        {{'front_landing.a_ticketing_made_for'| translate}}
      </p>
    </header>
    <div class="wrapper flexible">
      <div>
        <span class="img-wrapper"><img src="assets/imgs/landing/iPAD.png" class="img-fluid" alt="Vendez"></span>
      </div>
      <div>
        <ul class="list-wrapper">
          <li class="ddown-toggle active">
            <header class="text-blue">
              <h5 class="inline-block">{{'front_landing.sell_anywhere_whenever'| translate}}</h5>
              <i class="fa fa-angle-down align-right"></i>
            </header>
            <p>{{'front_landing.on_computer_smartphone'| translate}}</p>
            <p>{{'front_landing.just_after_creating_your_event_ticketing_online'| translate}}</p>
          </li>
          <li class="ddown-toggle">
            <header class="text-blue">
              <h5 class="inline-block">{{'front_landing.follow_your_sell_ib_real_time'| translate}}</h5>
              <i class="fa fa-angle-down align-right"></i>
            </header>
            <p>
              {{'front_landing.from_your_professional_ackces_account_'| translate}}
            </p>
          </li>
          <li class="ddown-toggle">
            <header class="text-blue">
              <h5 class="inline-block"> {{'front_landing.export_your_ticketing'| translate}} </h5>
              <i class="fa fa-angle-down align-right"></i>
            </header>
            <p> {{'front_landing.if_you_have_web_site_'| translate}}</p>
            <p>{{'front_landing.thanks_to_akces_wiget'| translate}}</p>
            <p>{{'front_landing.our_visitor_could_always_'| translate}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Contrôlez -->
<section id="controllez" class="paddings pro-section">
  <div class="container">
    <div class="wrapper flexible">
      <div class="akces-row row">
        <div class="col-md-7">
          <header class="control-header">
            <h2 class="control-header__title text-uppercase text-blue">{{'front_landing.control'| translate}}</h2>
            <p class="control-header__subtitle">{{'front_landing.visit_entrance_'| translate}}</p>
          </header>
          <div class="control-box text-left">
            <header class="control-box__title text-blue">{{'front_landing.a_solution_'| translate}}</header>
            <div class="control-box__content">
              <div>{{'front_landing.keep_looking_on_your_ticketing'| translate}}</div>
              <div>{{'front_landing.this_intern_program_help_you_to_easily'| translate}}</div>
              <div>{{'front_landing.check_ticketing_avoid_'| translate}}</div>
            </div>
            <a href="/manage/event/create" title="En savoir plus" class="btn">{{'front_landing.know_more'| translate}}</a>
          </div>
        </div>
        <div class="col-md-5">
          <span class="img-wrapper"><img src="assets/imgs/landing/SCAN.png" class="img-fluid" alt="iPhones"></span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Analysez -->
<section id="analysez" class="paddings pro-section">
  <div class="container">
    <header class="analyze-header text-center">
      <h2 class="text-uppercase text-blue">{{'front_landing.analyse'| translate}}</h2>
      <p>{{'front_landing.continued_improvement'| translate}}</p>
    </header>
    <div class="wrapper flexible">
      <div class="analyze-row row">
        <div class="col-md-7">
          <img src="assets/imgs/landing/IPAD_BAS.png" class="img-fluid" alt="Analysez...">
        </div>
        <div class="col-md-5 text-left">
          <div>
            <header class="text-blue">{{'front_landing.sall_rapport'| translate}}</header>
            <p>{{'front_landing.trace_the_balance_sheet'| translate}}</p>
          </div>
          <div>
            <header class="text-blue">{{'front_landing.diagnose_assess'| translate}}</header>
            <p>{{'front_landing.the_indicators_of_tables'| translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
